import { render, staticRenderFns } from "./createPickup.vue?vue&type=template&id=7c45f3da&scoped=true&"
import script from "./createPickup.vue?vue&type=script&lang=js&"
export * from "./createPickup.vue?vue&type=script&lang=js&"
import style0 from "./createPickup.vue?vue&type=style&index=0&id=7c45f3da&scoped=true&lang=css&"
import style1 from "./createPickup.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c45f3da",
  null
  
)

export default component.exports